import type { OrganizationInfo, UserInfo } from '../types';
import apiRequest from './apiRequest';

export default async function postOrganizationInviteAccept(
  organizationID: string,
  inviteID: string,
) {
  return apiRequest<{ organizationInfo: OrganizationInfo; userInfo: UserInfo }>(
    'user',
    '/organizations/invites/accept',
    {
      method: 'POST',
      body: JSON.stringify({ organizationID, inviteID }),
    },
  );
}
